import {
  ADOBE_SAVED_ITEM_ACTION_KEY,
  ADOBE_PRODUCTS_KEY,
  ADOBE_EVENTS_KEY,
  ADOBE_SORT_BY_KEY,
  ADOBE_SHARE_ID_KEY,
  ADOBE_BOARD_ID_KEY,
  ADOBE_WISHLIST_ACTION_KEY,
  ADOBE_SAVED_ITEMS_GOOGLE_ADVERT_ON_PAGE
} from "../../constants";
import {
  ITEMS_TYPE_CUSTOMER_ITEMS,
  ITEMS_TYPE_SHARED_BOARD,
  ITEMS_TYPE_SIMILAR
} from "../../../../constants";
import mapToEventsWithValues from "../../mapToEventsWithValues";

const itemsTypeMeasurementsMap = {
  [ITEMS_TYPE_CUSTOMER_ITEMS]: ({
    sortBy,
    savedItemAction,
    googleAdvertLoadedAction
  }) => ({
    [ADOBE_SORT_BY_KEY]: sortBy,
    [ADOBE_SAVED_ITEM_ACTION_KEY]: savedItemAction,
    [ADOBE_SAVED_ITEMS_GOOGLE_ADVERT_ON_PAGE]: googleAdvertLoadedAction
  }),
  [ITEMS_TYPE_SHARED_BOARD]: ({
    sortBy,
    wishlistAction,
    boardId,
    shareId
  }) => ({
    [ADOBE_SORT_BY_KEY]: sortBy,
    [ADOBE_WISHLIST_ACTION_KEY]: wishlistAction,
    [ADOBE_BOARD_ID_KEY]: boardId,
    [ADOBE_SHARE_ID_KEY]: shareId
  }),
  [ITEMS_TYPE_SIMILAR]: () => ({})
};

export default ({
  trackLink: {
    products,
    savedItemAction,
    wishlistAction,
    events,
    googleAdvertLoadedAction
  },
  sortBy,
  itemsType,
  boardId,
  shareId
}) => ({
  [ADOBE_PRODUCTS_KEY]: products,
  [ADOBE_EVENTS_KEY]: mapToEventsWithValues(events),
  ...itemsTypeMeasurementsMap[itemsType]({
    sortBy,
    savedItemAction,
    wishlistAction,
    boardId,
    shareId,
    googleAdvertLoadedAction
  })
});
